// extracted by mini-css-extract-plugin
export default {"quick-links-wrapper":"quick-links_quick-links-wrapper__l9Zk7"};